//------- Layouts ---------//
import AdminLayout from "../Layout/AdminLayout/AdminLayout";
import AuthenticationLayout from "../Layout/AuthenticationLayout/AuthenticationLayout";
import Login from "../View/Authentication/Login/Login";
import AdministratorUserList from "../View/Admin/Administrator/User/AdministratorUserList";
import AdministratorUser from "../View/Admin/Administrator/User/AdministratorUser";
import AdministratorRoleList from "../View/Admin/Administrator/Role/AdministratorRoleList";
import AdministratorMailLogList from "../View/Admin/Administrator/Log/AdministratorMailLogList";
import AdministratorCronLogList from "../View/Admin/Administrator/Log/AdministratorCronLogList";
import PrestationList from "../View/Admin/Configuration/Prestation/PrestationList";
import Prestation from "../View/Admin/Configuration/Prestation/Prestation";
import PrestationGroupList from "../View/Admin/Configuration/PrestationGroup/PrestationGroupList";
import PrestationGroup from "../View/Admin/Configuration/PrestationGroup/PrestationGroup";
import ProductList from "../View/Admin/Configuration/Product/ProductList";
import Product from "../View/Admin/Configuration/Product/Product";
import AvailabilityCalendar from "../View/Admin/Configuration/Availability/AvailabilityCalendar";
import Availability from "../View/Admin/Configuration/Availability/Availability";

import CrmCustomerList from "../View/Admin/CRM/Customer/CrmCustomerList";
import CrmCustomer from "../View/Admin/CRM/Customer/CrmCustomer";
import CrmAppointmentList from "../View/Admin/CRM/Appointment/CrmAppointmentList";
import CrmAppointment from "../View/Admin/CRM/Appointment/CrmAppointment";
import CrmAppointmentDay from "../View/Admin/CRM/Appointment/CrmAppointmentDay";
import AdminDashboard from "../View/Admin/Dashboard/AdminDashboard";
import PublicLayout from "../Layout/PublicLayout/PublicLayout";
import Catalogue from "../View/Public/Catalogue/Catalogue";
import CatalogueDetail from "../View/Public/Catalogue/CatalogueDetail";
import PublicAppointment from "../View/Public/Appointment/PublicAppointment";

//------- Routes ---------//
const routing = {
  //---------- PUBLIC ----------//
  public_catalogue: { path: "/public/catalogue", view: Catalogue, layout: PublicLayout, roles: []},
  public_catalogue_detail: { path: "/public/catalogue/:id", match: /\/public\/catalogue\/\d+$/, view: CatalogueDetail, layout: PublicLayout, roles: []},
  public_appointment_add: { path: "/public/rendez-vous", view: PublicAppointment, layout: PublicLayout, roles: []},
  public_appointment_add_prestation: { path: "/public/rendez-vous/:prestationId", match: /\/public\/rendez-vous\/\d+$/, view: PublicAppointment, layout: PublicLayout, roles: []},

  //---------- ADMIN ----------//
  admin_dashboard: { path: "/admin/dashboard", view: AdminDashboard, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR", "ROLE_CONFIGURATION", "ROLE_CRM"] },
  // ADMINISTRATOR
  administrator_user_list: { path: "/administrator/user/list", view: AdministratorUserList, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR"] },
  administrator_user: { path: "/administrator/user/:id", match: /\/administrator\/user.*/, view: AdministratorUser, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR"] },
  administrator_role_list: { path: "/administrator/role/list", view: AdministratorRoleList, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR"] },
  administrator_mail_log_list: { path: "/administrator/log/mail/list", view: AdministratorMailLogList, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR"] },
  administrator_cron_log_list: { path: "/administrator/log/cron/list", view: AdministratorCronLogList, layout: AdminLayout, roles: ["ROLE_ADMINISTRATOR"] },
  configuration_prestation_group_list: { path: "/configuration/prestation-group/list", view: PrestationGroupList, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_prestation_group: { path: "/configuration/prestation-group/:id", match: /\/configuration\/prestation-group.*/, view: PrestationGroup, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_prestation_list: { path: "/configuration/prestation/list", view: PrestationList, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_prestation: { path: "/configuration/prestation/:id", match: /\/configuration\/prestation.*/, view: Prestation, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_product_list: { path: "/configuration/product/list", view: ProductList, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_product: { path: "/configuration/product/:id", match: /\/configuration\/product.*/, view: Product, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_availability_list: { path: "/configuration/availability/list", view: AvailabilityCalendar, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  configuration_availability: { path: "/configuration/availability/:id", match: /\/configuration\/availability.*/, view: Availability, layout: AdminLayout, roles: ["ROLE_CONFIGURATION"] },
  // CRM
  crm_customer_list: { path: "/crm/customer/list", view: CrmCustomerList, layout: AdminLayout, roles: ["ROLE_CRM"] },
  crm_customer: { path: "/crm/customer/:id", match: /\/crm\/customer.*/, view: CrmCustomer, layout: AdminLayout, roles: ["ROLE_CRM"] },
  crm_appointment_list: { path: "/crm/appointment/list", view: CrmAppointmentList, layout: AdminLayout, roles: ["ROLE_CRM"] },
  crm_appointment_day: { path: "/crm/appointment/day/:date", match: /\/crm\/appointment\/day\/.*/, view: CrmAppointmentDay, layout: AdminLayout, roles: ["ROLE_CRM"] },
  crm_appointment: { path: "/crm/appointment/:id", match: /\/crm\/appointment.*/, view: CrmAppointment, layout: AdminLayout, roles: ["ROLE_CRM"] },
  //---------- ANONYMOUS ----------//
  // authentication_login: { path: "/authentication/login", view: Login, layout: AuthenticationLayout, roles: [] },
  authentication_admin: { path: "/authentication/admin", view: Login, layout: AuthenticationLayout, roles: [] },
  // authentication_register: { path: '/authentication/register', view: Register, layout: AuthenticationLayout, roles: [] },

};

//------- SECURITY ---------//
let routes = {};
let defaultPath = {};
let wasAuthenticated = false;
let redirectToAdminOnLogout = false;

export const updateRouting = (authReducer) => {
  routes = {};
  const isAuthenticated = !!(authReducer && authReducer.email);

  // Public routes: always available.
  for (let index in routing) {
    if (index.startsWith("public_") || routing[index].isPublic) {
      routes[index] = routing[index];
    }
  }

  if (isAuthenticated) {
    wasAuthenticated = true;

    for (let index in routing) {
      if (
        !index.startsWith("public_") &&
        !routing[index].isPublic &&
        authReducer.roles &&
        (authReducer.roles.includes("ROLE_SUPER_ADMIN") ||
          authReducer.roles.filter((value) => routing[index].roles.includes(value)).length > 0)
      ) {
        if (!(authReducer.roles.includes('ROLE_SUPER_ADMIN') && index.startsWith("customer_"))) {
          routes[index] = routing[index];
        }
      }
    }


    // routes.authentication_login = routing["authentication_login"];
    routes.authentication_admin = routing["authentication_admin"];
    // routes.authentication_register = routing["authentication_register"];

    const privateRouteId = Object.keys(routes).find(
      (id) => id !== "authentication_admin" && !id.startsWith("public_")
    );

    if (privateRouteId) {
      delete routes.authentication_admin;
      defaultPath = routes[privateRouteId].path;
    } else {
      defaultPath = getRoutePathname("authentication_admin");
    }
  } else {
    if (wasAuthenticated) {
      redirectToAdminOnLogout = true;
      wasAuthenticated = false;
    }

    // Logout
    // routes.authentication_login = routing["authentication_login"];
    routes.authentication_admin = routing["authentication_admin"];
    routes.public_catalogue = routing["public_catalogue"];
    // routes.authentication_register = routing["authentication_register"];
    if (redirectToAdminOnLogout) {
      defaultPath = getRoutePathname("authentication_admin");
      redirectToAdminOnLogout = false;
    } else {
      defaultPath = routes.public_catalogue
        ? routes.public_catalogue.path
        : getRoutePathname("authentication_admin");
    }
  }
};

export const getRoutes = () => {
  return routes;
};

export const getPathDefault = () => {
  return defaultPath;
};

export const getRoute = (id) => {
  let routes = getRoutes();
  let route = routes[id];
  return route ? { ...route, id: id } : {};
};

export const getRoutePathname = (id, params = {}) => {
  let route = getRoute(id);
  let path = route.path ?? "/";

  for (let index in params) {
    let regex = new RegExp("/:" + index + "[?]{0,1}", "gi");
    path = path.replace(regex, params[index] ? "/" + params[index] : "");
  }

  return path;
};

export const getRouteByPathname = (pathname) => {
  let routes = getRoutes();

  for (let index in routes) {
    if (routes[index].match && routes[index].match.test(pathname)) {
      return { ...routes[index], id: index };
    } else if (routes[index].path === pathname) {
      return { ...routes[index], id: index };
    }
  }

  return {};
};
